<template>
  <SimpleBar
    v-bind="$attrs"
    :options="settings"
    class="base-scroll">
    <slot />
  </SimpleBar>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import SimpleBar from 'simplebar-vue'
import 'simplebar-vue/dist/simplebar.min.css'

export default defineComponent({
  name: 'Scroll',
  components: { SimpleBar },
  inheritAttrs: false,
  props: {
    settings: {
      type: Object,
      default: () => ({}),
    },
  },
})
</script>